<template>
  <div class="contact-us-background">
    <div class="contact-us-banner">
      <div class="contact-us-container">
        <div class="contact-us-banner-title">联系我们</div>
      </div>

      <img class="contact-us-banner-img" src="../../assets/about/banner.png" />
    </div>
    <div class="contact-us-container">
      <div class="contact-us-content">
        <div class="contact-us-content-title">
          <div class="contact-us-content-title-text">一体化全方位服务</div>
        </div>
        <div class="contact-us-content-info">
          <p class="contact-us-content-info-title-text">
            <i class="fa fa-handshake-o contact-us-content-info-title-fa"></i
            >销售：
          </p>
          <p class="contact-us-content-info-text">
            “龙讯”主要销售MSTATION、MCLUSTER及PWmat软件包，同时还提供计算机时服务。具体细节请联系我们的销售及售前经理。
          </p>
          <p class="contact-us-content-info-title-text">
            <i class="fa fa-handshake-o contact-us-content-info-title-fa"></i
            >售后：
          </p>
          <p class="contact-us-content-info-text">
            “龙讯”还提供完善的售后服务，具体细节请联系我们的客服。
          </p>
          <p class="contact-us-content-info-title-text">
            <i class="fa fa-handshake-o contact-us-content-info-title-fa"></i
            >合作：
          </p>
          <p class="contact-us-content-info-text">
            “龙讯”还提供平面波相关数值软件开发的服务，同时也希望与广大科研人员共同推动国产量子计算模拟软件的发展。
          </p>
        </div>
        <div class="contact-us-content-line"></div>

        <div class="contact-us-content-title">
          <div class="contact-us-content-title-text">联系方式</div>
        </div>

        <baidu-map
          class="contact-us-map"
          :center="{ lng: 116.360203, lat: 40.021519 }"
          :zoom="17"
        >
          <bm-marker
            :position="{ lng: 116.360203, lat: 40.021519 }"
            :dragging="true"
            @click="infoWindowOpen"
          >
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
            <bm-info-window
              :show="show"
              @close="infoWindowClose"
              @open="infoWindowOpen"
            >
              <p style="margin-bottom: 2px">
                北京市海淀区学清路8号科技财富中心A座908室
              </p>
              <p style="margin-bottom: 2px">电话：400-618-6006</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map>

        <div class="contact-us-content-info contract-us-content-info-phone">
          <p class="contact-us-content-info-text">
            <a class="contact-us-content-info-phone-text">销售电话：</a
            >400-618-6006
          </p>
          <p class="contact-us-content-info-text">
            <a class="contact-us-content-info-phone-text">售前电话：</a
            >400-618-6006
          </p>
          <p class="contact-us-content-info-text">
            <a class="contact-us-content-info-phone-text">邮箱：</a
            >support@pwmat.com
          </p>
          <p class="contact-us-content-info-text">
            <a class="contact-us-content-info-phone-text">微信公众号：</a
            >公众号搜索“PWmat1”
          </p>
          <p class="contact-us-content-info-text">
            <a class="contact-us-content-info-phone-text">地址：</a
            >北京市海淀区学清路8号科技财富中心A座908室
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
export default {
  name: "companyIntroduce",
  data() {
    return {
      show: true,
    };
  },
  components: {
    BaiduMap,
  },
  methods: {
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    },
  },
};
</script>

<style scoped>
.contact-us-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.contact-us-background {
  margin-top: 70px;
}
.contact-us-banner {
  overflow: hidden;
}
.contact-us-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.contact-us-banner-img {
  min-width: 100%;
  height: 165px;
}
.contact-us-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.contact-us-content-title {
  padding-top: 50px;
  text-align: center;
}
.contact-us-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.contact-us-content-info {
  margin-top: 50px;
}
.contact-us-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.contact-us-content-info-title-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: bolder;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.contact-us-content-info-title-fa {
  font-size: 22px;
  padding-right: 8px;
}
.contact-us-content-line {
  margin-top: 50px;
  height: 1px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.1;
}
.contact-us-content-info-phone-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: bolder;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.contact-us-map {
  margin-top: 50px;
  width: 550px;
  height: 350px;
  display: inline-block;
  vertical-align: top;
  border: 4px solid gainsboro;
}
.contract-us-content-info-phone {
  width: 438px;
  display: inline-block;
  vertical-align: top;
  padding-left: 60px;
}

@media screen and (max-width: 482px) {
  .contact-us-container {
    max-width: 100%;
  }
  .contact-us-map {
    width: 100%;
    height: 286px;
    display: block;
    vertical-align: unset;
  }
  .contract-us-content-info-phone {
    width: unset;
    display: unset;
    vertical-align: unset;
    margin-top: 50px;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .contact-us-container {
    max-width: 450px;
  }
  .contact-us-map {
    width: 450px;
    height: 286px;
    display: block;
    vertical-align: unset;
  }
  .contract-us-content-info-phone {
    width: unset;
    display: unset;
    vertical-align: unset;
    margin-top: 50px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .contact-us-container {
    max-width: 736px;
  }
  .contact-us-map {
    width: 736px;
    height: 468px;
    display: block;
    vertical-align: unset;
  }
  .contract-us-content-info-phone {
    width: 438px;
    display: unset;
    vertical-align: unset;
    margin-top: 50px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .contact-us-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .contact-us-container {
    max-width: 1068px;
  }
}
</style>
